export const PAPER_SIZES = ['card', 'letter', 'A4', 'large_print']

export const PAPER_SIZE_LABELS = {
  card: 'Card (8 x 8.5in)',
  letter: 'Letter (8.5in x 11in)',
  large_print: 'Large Print Letter (8.5in x 11in)',
  A4: 'A4 (21cm x 29.7cm)',
}
